import createIcon from '../../createIcon';

/**
 * @component @name SmartScreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNUgzQzEuOSA1IDEgNS45IDEgN1YxN0MxIDE4LjEgMS45IDE5IDMgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjdDMjMgNS45IDIyLjEgNSAyMSA1Wk0xOCAxN0g2VjdIMThWMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYuNSAxMS4yNUgxNVYxMi43NUgxNi41VjExLjI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDExLjI1SDEyLjVWMTIuNzVIMTRWMTEuMjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTEuNSAxMS4yNUgxMFYxMi43NUgxMS41VjExLjI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgMTEuMjVINy41VjEyLjc1SDlWMTEuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SmartScreen = createIcon('SmartScreen', [
  [
    'path',
    {
      d: 'M21 5H3C1.9 5 1 5.9 1 7V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5ZM18 17H6V7H18V17Z',
      key: '6onlsu',
    },
  ],
  ['path', { d: 'M16.5 11.25H15V12.75H16.5V11.25Z', key: 'fgfd94' }],
  ['path', { d: 'M14 11.25H12.5V12.75H14V11.25Z', key: '1l36yd' }],
  ['path', { d: 'M11.5 11.25H10V12.75H11.5V11.25Z', key: '3qnef1' }],
  ['path', { d: 'M9 11.25H7.5V12.75H9V11.25Z', key: '6b1apc' }],
]);

export default SmartScreen;
